// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;O that today you would listen to his voice:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#145;Harden not your hearts as at Meribah,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;on that day at Massah in the wilderness,<br> </p> </div></div>";
// Exports
module.exports = code;